
import React, { useEffect, useState } from "react";
import { faPencil, faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Card, CardBody, CardHeader, Col, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import DataTable from "datatables.net-react";
import DT from "datatables.net-bs5";
import "datatables.net-responsive-dt";
import { useApiStore } from "../../hooks/ApiStoreContext";
import Swal from "sweetalert2";

function User() {
  const apiStore = useApiStore();
  DataTable.use(DT);
  const navigate = useNavigate();
  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    getUserList();
  }, []);

  const getUserList = async () => {
    try {
      const response = await apiStore.get("/users");
      setTableData(response);
    } catch (error) {
      console.error("There was an error fetching users!", error);
    }
  };

  const handleAdd = (e) => {
    e.preventDefault();
    navigate("/add-user");
  };

  const handleEdit = (e, id) => {
    e.preventDefault();
    navigate("/add-user/" + id);
  };

  const handleDelete = async (e, id) => {
    e.preventDefault();

    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
      reverseButtons: true,
    });

    if (result.isConfirmed) {
      try {
        await apiStore.delete(`/users/${id}`);
        await Swal.fire("Deleted!", "User deleted successfully.", "success");
        getUserList();
      } catch (error) {
        if (error.response.status !== 401) {
          console.error("There was an error deleting the user!", error);
          if (error.response && error.response.status == 409 && error.response.data) {
            Swal.fire("Error!", error.response.data, "error");
          } else {
            Swal.fire("Error!", "There was an error deleting the user.", "error");
          }
        }
      }
    } else if (result.dismiss === Swal.DismissReason.cancel) {
      Swal.fire("Cancelled", "Your user is safe :)", "error");
    }
  };

  const handleStatus = async (e, data, row) => {
    try {
      const submitData = {
        userId: row.userId,
        firstName: row.firstName,
        lastName: row.lastName,
        loginId: row.loginId,
        email: row.email,
        contact: row.contact,
        roleId: row.roleId,
        password: row.password,
        isActive: !data,
      };
      await apiStore.put(`/users/${row.userId}`, submitData);
      getUserList();
    } catch (error) {
      if (error.response.status !== 401) {
        console.error("There was an error updating the user status!", error);
      }
    }
  };

  return (
    <Row>
      <Col md={12}>
        <Card className="mb-4">
          <CardHeader className="pb-0">
            <Row>
              <Col md={9}>
                <h4>User List</h4>
              </Col>
              <Col md={3} className="d-grid d-md-flex justify-content-md-end d-sm-block">
                <Button variant="outline-primary" className="btn-sm" onClick={handleAdd}>
                  Add User
                </Button>
              </Col>
            </Row>
          </CardHeader>
          <CardBody className="px-0 pt-0 pb-2">
            <div className="mx-3">
              <DataTable
                className="display table align-items-center mb-0 p-0"
                data={tableData}
                options={{
                  responsive: true,
                  columns: [
                    { data: "firstName", className: "text-secondary text-sm font-weight-bold align-middle" },
                    { data: "lastName", className: "text-secondary text-sm font-weight-bold align-middle" },
                    { data: "loginId", className: "text-secondary text-sm font-weight-bold align-middle" },
                    { data: "email", className: "text-secondary text-sm font-weight-bold align-middle" },
                    { data: "contact", className: "text-secondary text-sm font-weight-bold align-middle" },
                    { data: "roleName", className: "text-secondary text-sm font-weight-bold align-middle" },
                    { data: "isActive", className: "text-sm font-weight-bold align-middle text-center" },
                    { data: "userId", className: "text-secondary text-sm font-weight-bold align-middle text-center" },
                  ],
                }}
                slots={{
                  6: (data, row) => {
                    return (
                      <React.Fragment>
                        <span className={data ? "badge badge-sm cursor-pointer bg-gradient-success" : "badge badge-sm cursor-pointer bg-gradient-danger"} onClick={(e) => handleStatus(e, data, row)}>
                          {data ? "Active" : "Inactive"}
                        </span>
                      </React.Fragment>
                    );
                  },
                  7: (data, row) => {
                    return (
                      <React.Fragment>
                        <a className="me-3 cursor-pointer" title="Edit" onClick={(e) => handleEdit(e, data)}>
                          <FontAwesomeIcon icon={faPencil} size="lg"></FontAwesomeIcon>
                        </a>
                        <a className="text-danger cursor-pointer" title="Delete" onClick={(e) => handleDelete(e, data)}>
                          <FontAwesomeIcon icon={faTrashCan} size="lg"></FontAwesomeIcon>
                        </a>
                      </React.Fragment>
                    );
                  },
                }}>
                <thead>
                  <tr>
                    <th className="text-uppercase text-secondary text-sm font-weight-bolder">Company</th>
                    <th className="text-uppercase text-secondary text-sm font-weight-bolder">Contact Person</th>
                    <th className="text-uppercase text-secondary text-sm font-weight-bolder">Login Id</th>
                    <th className="text-uppercase text-secondary text-sm font-weight-bolder">Email</th>
                    <th className="text-uppercase text-secondary text-sm font-weight-bolder">Contact</th>
                    <th className="text-uppercase text-secondary text-sm font-weight-bolder">Role</th>
                    <th className="text-center text-uppercase text-secondary text-sm font-weight-bolder">Status</th>
                    <th className="text-center text-uppercase text-secondary text-sm font-weight-bolder">Action</th>
                  </tr>
                </thead>
              </DataTable>
            </div>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
}

export default User;